import React, { StrictMode } from 'react';
import ReactDOM from 'react-dom/client'; // ✅ React 18 client API
import { Provider } from 'react-redux';
import App from './App';
import PublicApp from './PublicApp';
import { Auth0Provider } from "@auth0/auth0-react";
import CustomAuthProvider from './providers/CustomAuthProvider';
import { configureStore } from './redux/store';
import history from "./utils/history";
import getConfig from "./config";
import './styles/custom.css';

const store = configureStore({});

// 1. Dynamically load the FontAwesome Kit script
const faScript = document.createElement('script');
faScript.src = 'https://kit.fontawesome.com/303951ae59.js';
faScript.crossOrigin = 'anonymous';
document.head.appendChild(faScript);

const onRedirectCallback = (appState) => {
  history.push(
    appState && appState.returnTo ? appState.returnTo : window.location.pathname
  );
};

const _config = getConfig();

const providerConfig = {
  domain: _config.domain,
  clientId: _config.clientId,
  ...(_config.audience ? { audience: _config.audience } : null),
  redirectUri: window.location.origin,
  onRedirectCallback
};

const publicPaths = ["/public", "/signup"];
const isPublicPage = publicPaths.some((p) => window.location.pathname.startsWith(p));

// ✅ Create root using React 18 API
const rootElement = document.getElementById("root");
const root = ReactDOM.createRoot(rootElement);

const resizeObserverLoopErrRe =
  /ResizeObserver loop completed with undelivered notifications/i;

const origError = console.error;
console.error = (...args) => {
  if (resizeObserverLoopErrRe.test(args[0])) {
    return;
  }
  origError(...args);
};

window.addEventListener("error", (e) => {
  if (resizeObserverLoopErrRe.test(e.message)) {
    e.stopImmediatePropagation();
  }
});

root.render(
  isPublicPage ? (
    <StrictMode>
      <PublicApp />
    </StrictMode>
  ) : (
    <Provider store={store}>
      <Auth0Provider {...providerConfig} scope="access:INS">
        <CustomAuthProvider>
          <StrictMode>
            <App />
          </StrictMode>
        </CustomAuthProvider>
      </Auth0Provider>
    </Provider>
  )
);